export default __webpack_public_path__ + "static/photo-bar-5-436fd578a196adb8c9171d0ac23d9550.jpg";